'use client'

import DocPage from './DocPage'

export default function Payment({ vendor }: { vendor?: any }) {
  return (
    <DocPage
      vendor={vendor}
      pageKey="payment"
      titleLead="Төлбөрийн"
      titleAccent="нөхцөл"
      description="Дэмжигдсэн төлбөрийн арга, гүйлгээний зөвлөмж, баталгаажуулалтын процесстой холбоотой мэдээлэл."
      htmlContent={vendor?.terms?.payment}
      emptyMessage="Одоогоор төлбөрийн нөхцөл нэмэгдээгүй байна."
    />
  )
}
